module.exports = __webpack_public_path__ + "img/gauge-min-solid.b5fa8f08.svg";